<template>
  <div class="layout-container">
    <top-bar></top-bar>
    <nav-bar></nav-bar>
    <app-main></app-main>
  </div>
</template>

<script>
  import TopBar from './components/TopBar'
  import NavBar from './components/navBar/index'
  import AppMain from './components/AppMain'
  export default {
    name: 'Layout',
    components: {
      TopBar,
      NavBar,
      AppMain
    }
  }
</script>

<style scoped >
  .layout-container {
    /*padding-left: 12%;
    padding-right: 12%;*/
  }
</style>